import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

interface CommonNoticeDto {
  title: string; // 공지 제목
  createdAt: string; // 공지 날짜
}

export const NoticeSection = ({ notice }: { notice: CommonNoticeDto[] }) => {
  const history = useHistory();
  const noticeClickHandler = () => {
    history.push('/notice');
  };
  return (
    <Wrap>
      <span className="title">공지사항</span>
      <div className="notice-box">
        {notice && notice.length > 0 ? (
          <ul onClick={noticeClickHandler}>
            {notice.map((item, index) => (
              <li key={index}>
                <span className="notice-title">{item.title}</span>
                <span className="notice-date">{item.createdAt}</span>
              </li>
            ))}
          </ul>
        ) : (
          <p className="no-notice">공지사항이 없습니다.</p>
        )}
      </div>
    </Wrap>
  );
};

// style
const Wrap = styled.section`
  .no-notice {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.6rem;
  }
  margin-top: 3.2rem;
  .title {
    display: flex;
    align-items: center;
    font-size: 1.6rem;
    font-weight: 600;
    margin-bottom: 1.4rem;
  }
  .notice-box {
    min-height: 12.8rem;
    background-color: ${(props) => props.theme.textWhiteColor};
    padding: 2.4rem 1rem;
    border-radius: 1.6rem;
    box-shadow: rgba(188, 191, 209, 0.2) 0px 2px 6px;
    ul {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;
      li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .notice-title {
          font-size: 1.4rem;
          font-weight: 600;
          padding: 0 0.6rem;
          flex: 1;
          max-width: 23.8rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .notice-date {
          font-size: 1.2rem;
          font-weight: 400;
          color: ${(props) => props.theme.joinLabelColor};
          flex-basis: 7.6rem;
        }
      }
    }
  }
`;
